import React from 'react';
export function BdFlag({
  width = 24,
  className
}: {
  width?: number;
  className?: string;
}) {
  return <svg width={width} height={width * 3 / 5} viewBox="0 0 10 6" className={className} role="img" aria-label="বাংলাদেশের পতাকা" data-id="element-112" data-mp="9a0zrt0z9n84">
      <rect width="10" height="6" fill="#006a4e" rx="0.4" data-id="element-113" data-mp="nalf2f7op0wv" />
      <circle cx="4.5" cy="3" r="2" fill="#f42a41" data-id="element-114" data-mp="i9e7ag5jk1q7" />
    </svg>;
}